import { Container, Grid } from '@mui/material'
import { styled } from '@mui/system'
import moment from 'moment'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router'
import { showSlider } from '../../../../../redux/actions/sliders'
import { IRootState } from '../../../../../redux/types'
import DetailHeroPanel from '../../../../shared/components/DetailHeroPanel'
import DetailInfoPanel from '../../../../shared/components/DetailInfoPanel'
import ButtonBack from '../../../../shared/components/buttons/ButtonBack'
import VerifyAccessRoute from '../../../../shared/components/routes/VerifyAccessRoute'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { MoreInfoDetail } from '../../../library/models/resource'
import AdminDetailInfo from '../../../library/ui/components/AdminDetailInfo'

const SlideImage = styled('img')({
  borderRadius: '0px 0px 0px 16px',
  maxWidth: '100%'
})

function SliderDetail() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const { id } = useParams<{ id: string }>()
  const dispatch = useDispatch()
  const location = useLocation()

  const { slider_selected } = useSelector((state: IRootState) => state.slider)

  useEffect(() => {
    dispatch(showSlider(id))
  }, [])

  let infoDetail: MoreInfoDetail = {
    item: [
      {
        id: 1,
        type: 'date',
        title: `${t('admin.people.created-date')}`,
        color: 'grey6',
        info: `${moment(slider_selected?.created_at).format('LL')}`
      }
    ]
  }

  return (
    <>
      {slider_selected != null && (
        <Container id="slider-detail">
          <ButtonBack />
          <Grid container spacing={5} direction="row-reverse">
            <Grid item xs={12} md={4}>
              <DetailHeroPanel
                visibility={slider_selected.visibility}
                status={slider_selected.status}
                brand={slider_selected.brand_id}
                title={slider_selected.title}
                author={slider_selected.created_by}
                description={slider_selected.description}
              />
              {isMobile ? <></> : <DetailInfoPanel attributes={infoDetail} />}
            </Grid>

            <Grid id="slider-detail-hero" item xs={12} md={8}>
              <VerifyAccessRoute visibility={slider_selected.visibility} />

              {location.pathname.includes('admin') && <AdminDetailInfo resourceSelected={slider_selected} />}

              {slider_selected.image != null && <SlideImage src={slider_selected.image} alt={slider_selected.title} />}

              {isMobile ? <DetailInfoPanel attributes={infoDetail} /> : <></>}
            </Grid>
          </Grid>
        </Container>
      )}
    </>
  )
}

export default SliderDetail
